var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBarChart = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 9.333H6.133c-.746 0-1.12 0-1.405.146-.25.127-.455.331-.583.582C4 10.347 4 10.72 4 11.467v14.4c0 .746 0 1.12.145 1.405.128.25.332.455.583.583.285.145.659.145 1.405.145H12m0 0h8m-8 0V6.133c0-.746 0-1.12.145-1.405.128-.25.332-.455.583-.583C13.013 4 13.387 4 14.133 4h3.734c.746 0 1.12 0 1.405.145.25.128.455.332.583.583.145.285.145.659.145 1.405V28m0-13.333h5.867c.746 0 1.12 0 1.405.145.25.128.455.332.583.583.145.285.145.658.145 1.405v9.067c0 .746 0 1.12-.145 1.405-.128.25-.332.455-.583.583-.285.145-.659.145-1.405.145H20",
  stroke: "currentColor",
  strokeWidth: 2.667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgBarChart;